import { render, staticRenderFns } from "./menuManage.vue?vue&type=template&id=a1672818&scoped=true"
import script from "./menuManage.vue?vue&type=script&lang=js"
export * from "./menuManage.vue?vue&type=script&lang=js"
import style0 from "./menuManage.vue?vue&type=style&index=0&id=a1672818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1672818",
  null
  
)

export default component.exports